import React from 'react';
import DomainGroupLogo from '@domain-group/fe-co-domain-group-logo';
import { ChevronLeftIconSmall } from '@domain-group/fe-co-icon';
import { Button } from '@domain-group/fe-co-allhomes-design-system';
import PropTypes from 'prop-types';
import * as styles from './footer.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var Footer = props => ___EmotionJSX("div", {
  css: styles.footerSection
}, ___EmotionJSX(ChevronLeftIconSmall, null), ___EmotionJSX(Button, {
  appearance: "ghost",
  onClick: props.onCloseModal,
  tabIndex: 0
}, "Cancel"), ___EmotionJSX("div", {
  css: styles.companyName
}, ___EmotionJSX("span", null, ___EmotionJSX("a", {
  href: props.domainGroupUrl,
  tabIndex: 0
}, ___EmotionJSX(DomainGroupLogo, {
  primaryFill: "black",
  secondaryFill: "black"
}))), ___EmotionJSX("a", {
  href: props.allhomesUrl,
  css: styles.companyAllhomes,
  tabIndex: 0
}, "\xA9 AllHomes Pty Ltd")));
Footer.propTypes = {
  onCloseModal: PropTypes.func,
  domainGroupUrl: PropTypes.string,
  allhomesUrl: PropTypes.string
};
Footer.defaultProps = {
  onCloseModal: () => {},
  domainGroupUrl: 'https://www.domain.com.au/group/',
  allhomesUrl: 'https://www.allhomes.com.au/ah/act/info/site-map/view'
};
export default Footer;